export enum Alarm {
  BEFORE_15_MIN = 'BEFORE_15_MIN',
  BEFORE_30_MIN = 'BEFORE_30_MIN',
  BEFORE_60_MIN = 'BEFORE_60_MIN',
  NO_ALARM = 'NO_ALARM',
  ON_TIME = 'ON_TIME',
}

export enum DayContentMode {
  ADD,
  EDIT,
  VIEW,
}

export type DaysOfRepeat = [
  boolean,
  boolean,
  boolean,
  boolean,
  boolean,
  boolean,
  boolean,
];

export type DayIndex = 0 | 1 | 2 | 3 | 4 | 5 | 6;

export type DaysOfRepeatChangeHandler = (
  index: DayIndex,
  value: boolean,
) => void;
